<template>
  <div>
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
         <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/adm_master/usuarios">Usuários</router-link>
          </li>
          <li class="breadcrumb-item active">Detalhes do Usuário</li>
        </ol>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-info-circle"></i>Informações do Usuário
            </h2>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Nome</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="usuario.name"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>E-Mail</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="usuario.email"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Telefone</label>
                <input
                  type="text"
                  class="form-control"
                  v-mask="maskTel()"
                  v-model="usuario.telefone"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Senha</label>
                <input
                  type="password"
                  class="form-control"
                  placeholder
                  v-model="usuario.password"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Confirme sua Senha</label>
                <input
                  type="password"
                  class="form-control"
                  placeholder
                  v-model="usuario.confirmaPassword"
                />
              </div>
            </div>
            
            <div class="col-md-4">
              <div class="form-group">
                <label>Tipo de Usuário</label>
                <v-select
                  label="option"
                  v-model="usuario.role"
                  class="form-select"
                  :reduce="options => options.id"
                  :options="options"
                  :searchable="true"
                >
                </v-select>
              </div>
            </div>
          </div>

          <div v-if="usuario.role === 2" class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Empresa</label>
                <v-select
                  label="nome_empresa"
                  v-model="usuario.empresas_id"
                  class="form-select"
                  :reduce="empresas => empresas.id"
                  :options="empresas"
                  :searchable="true"
                >
                </v-select> 
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Usuário Principal</label>
                <v-select
                  label="option"
                  v-model="usuario.empresa_master"
                  class="form-select"
                  :reduce="optionsPrincipal => optionsPrincipal.id"
                  :options="optionsPrincipal"
                  :searchable="true"
                >
                </v-select> 
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <p class="pull-right">
                <button href="#0" class="btn_1 medium" @click="editaInformacoes()">Salvar</button>
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta, validaCampos, confereSenha, stripTelefone } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from 'axios'

export default {
  mixins: [funcoesGerais],
  data() {
    return {
      id_usuario: this.$route.params.id_user,
			isLoading: false,
      usuario: {},
      empresas: [],
      options: [
        { option: 'Master', id: 1 },
        { option: 'Empresa', id: 2 }
      ],
      optionsPrincipal: [
        { option: 'Não', id: 0 },
        { option: 'Sim', id: 1 }
      ],
    };
  },

  mounted() {
    let self = this;
    self.isLoading = true;
    axios.all([
      axios.get(`users/${self.id_usuario}`),
      axios.get('empresas')
    ])
      .then(axios.spread((userRes, empresasRes) => {
        self.usuario = userRes.data;
        self.empresas = empresasRes.data;
        self.usuario.confirmaPassword = self.usuario.password;
        self.isLoading = false;

      }, err => {
        self.isLoading = false;
        tratamento_requisicao(err);
      }))
  },
  methods: {
    maskTel() {
      let self = this;
      if(self.usuario.telefone)
        return self.usuario.telefone.length == 15 || !self.usuario.telefone.includes('-') ? '(##) #####-####' : '(##) ####-####'
    },
    editaInformacoes() {
      let self = this;
      if(validaCampos(self.usuario.email, undefined, self.usuario.telefone, undefined) &&
        confereSenha(self.usuario.password, self.usuario.confirmaPassword)){
          self.isLoading = true;
          let objRequest = {}
          objRequest.name = self.usuario.name
          objRequest.telefone = stripTelefone(self.usuario.telefone)
          objRequest.email = self.usuario.email
          objRequest.role = self.usuario.role
          objRequest.empresas_id = self.usuario.empresas_id
          objRequest.empresa_master = self.usuario.empresa_master

          if (self.usuario.role === 1)
            objRequest.empresas_id = null

          if (self.usuario.password)
            objRequest.password = self.usuario.password

        ajax("put", "users/" + self.usuario.id, objRequest)
          .then(() => {
            self.isLoading = false;
            alerta(
              "success",
              "Sucesso",
              "Informações foram atualizadas com sucesso!"
            );
          })
          .catch(error => {
            self.isLoading = false;
            tratamento_requisicao(error);
          });
      }
		}
  }
};
</script>

<style>

.img {
  display: flex;
  align-items: center;
}

</style>
